(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[97713,43440],{

/***/ 30877:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.e = function BsThreeDots (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 16 16","fill":"currentColor"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M3 9.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z","clipRule":"evenodd"}}]})(props);
};


/***/ }),

/***/ 15787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w_": function() { return /* reexport */ GenIcon; }
});

// UNUSED EXPORTS: DefaultContext, IconBase, IconContext, IconsManifest

;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/iconsManifest.js
var IconsManifest = [
  {
    "id": "fa",
    "name": "Font Awesome",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons 4",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "io5",
    "name": "Ionicons 5",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/refactoringui/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  }
]
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/iconContext.js

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = react.createContext && react.createContext(DefaultContext);
;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/iconBase.js
var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return react.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}

function GenIcon(data) {
  return function (props) {
    return react.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
        size = props.size,
        title = props.title,
        svgProps = __rest(props, ["attr", "size", "title"]);

    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + ' ' : '') + props.className;
    return react.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && react.createElement("title", null, title), props.children);
  };

  return IconContext !== undefined ? react.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/index.js




/***/ }),

/***/ 97713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9012);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _context_TranslationContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73040);
/* harmony import */ var _KiralaGelBanner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14082);
/* harmony import */ var _windowDimension__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16625);
/* harmony import */ var _ListVilla__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43440);








var Products = function(param) {
    var HomeContent = param.HomeContent, all = param.all, deviceType = param.deviceType;
    var allRentalVillas = (0,_context_TranslationContext__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .m)().allRentalVillas;
    var width = (0,_windowDimension__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)().width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            HomeContent && HomeContent.map(function(item, key) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ListVilla__WEBPACK_IMPORTED_MODULE_7__["default"], {
                            title: item.title,
                            description: item.kisa_icerik,
                            baslik: item.baslik,
                            showall: item.url,
                            fetch: (0,_api__WEBPACK_IMPORTED_MODULE_2__/* .GetVillasByKey */ .Bz)(item.key),
                            IconUrl: item.key == "BookableDirectly" ? "/icons/kt-logo.svg" : ""
                        }),
                        key == 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_KiralaGelBanner__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                src: width && width > 640 ? "/images/kiralagel-banner/1350x210.jpeg" : "/images/kiralagel-banner/575x260.png",
                                heightClass: width && width > 640 ? "h-52" : "h-60",
                                deviceType: deviceType
                            })
                        })
                    ]
                }, item.id);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                    href: all.url,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        title: all.title,
                        className: "bg-brand-blue-2 font-bold text-sm text-white py-5 px-8 inline-block mb-4 mx-auto lg:hidden ",
                        children: allRentalVillas
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Products);


/***/ }),

/***/ 14082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var is_mobile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63805);
/* harmony import */ var is_mobile__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(is_mobile__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_getMobilePlatform__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62647);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _context_TranslationContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73040);





var KiralaGelBanner = function(param) {
    var src = param.src, listingPage = param.listingPage, roundedClass = param.roundedClass, deviceType = param.deviceType;
    var learnMore = (0,_context_TranslationContext__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .m)().learnMore;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("https://www.kiralagel.com"), href = ref[0], setHref = ref[1];
    var isWide = src === null || src === void 0 ? void 0 : src.includes("1350x210");
    var aspectClass = isWide ? "aspect-[1350/210]" : "aspect-[575/260]";
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var isPhone = is_mobile__WEBPACK_IMPORTED_MODULE_1___default()();
        var platform = (0,_utils_getMobilePlatform__WEBPACK_IMPORTED_MODULE_4__/* .getMobilePlatform */ .W)();
        var mobileHref = platform === "ios" || deviceType === "ios" ? "https://apps.apple.com/us/app/kiralagel/id6762357016" : "https://play.google.com/store/apps/details?id=com.boceksoftware.kiralagelapp";
        setHref(isPhone || deviceType ? mobileHref : "https://www.kiralagel.com");
    }, [
        deviceType
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: href,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "block w-full ".concat(aspectClass, " bg-contain bg-no-repeat bg-center relative ").concat(roundedClass, " ").concat(listingPage ? "" : " my-6 xl:my-10"),
        style: {
            backgroundImage: "url(".concat(src, ")")
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "absolute bottom-4 left-1/2 -translate-x-1/2 text-[rgba(52,55,56,1)] bg-white/60 backdrop-blur- z-10 px-4 sm:px-8 py-2 sm:py-3 rounded-full font-bold shadow-xl transform transition-all duration-300 hover:bg-white hover:scale-105 active:scale-95 whitespace-nowrap text-sm lg:text-base tracking-wide",
            children: learnMore
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (KiralaGelBanner);


/***/ }),

/***/ 43440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _react_icons_all_files_bs_BsThreeDots__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(30877);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22920);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var is_mobile__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63805);
/* harmony import */ var is_mobile__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(is_mobile__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _context_TranslationContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73040);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _hooks_useVisible__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26279);
/* harmony import */ var _ListVilla_SkeletonView__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1550);












var ListVilla = function(props) {
    var ref = (0,_context_TranslationContext__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .m)(), all = ref.all, showAll = ref.showAll;
    var isPhone = is_mobile__WEBPACK_IMPORTED_MODULE_5___default()();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), data = ref1[0], setData = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), error = ref2[0], setError = ref2[1];
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_hooks_useVisible__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        rootMargin: "400px"
    }), 2), ref4 = ref3[0], isVisible = ref3[1];
    var DesktopView = false;
    var MobileView = false;
    if (isPhone) {
        MobileView = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
            return Promise.all(/* import() */[__webpack_require__.e(9842), __webpack_require__.e(56494), __webpack_require__.e(70235), __webpack_require__.e(29007)]).then(__webpack_require__.bind(__webpack_require__, 40880));
        }, {
            loadableGenerated: {
                webpack: function() {
                    return [
                        /*require.resolve*/(40880)
                    ];
                }
            }
        });
    } else {
        DesktopView = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
            return Promise.all(/* import() */[__webpack_require__.e(24366), __webpack_require__.e(9842), __webpack_require__.e(56494), __webpack_require__.e(70235), __webpack_require__.e(67323)]).then(__webpack_require__.bind(__webpack_require__, 77231));
        }, {
            loadableGenerated: {
                webpack: function() {
                    return [
                        /*require.resolve*/(77231)
                    ];
                }
            }
        });
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!isVisible) return;
        props.fetch.then(function(response) {
            if (response.data.error) {
                setError(response.data.error);
                setData(false);
            } else {
                setData(response.data);
                setError(false);
            }
        }).catch(function(error) {
            react_toastify__WEBPACK_IMPORTED_MODULE_3__/* .toast.error */ .Am.error(error.message);
            setError(error.message);
        });
    }, [
        isVisible
    ]);
    if (error) {
        return false;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: ref4,
        className: (props.className ? props.className : "odd:bg-brand-gray-7 bg-white") + " py-4 lg:pt-16 lg:pb-28 overflow-hidden ListVilla",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col gap-y-6 lg:gap-y-16",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            props.IconUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                                src: "/icons/kt-logo.svg",
                                width: 42,
                                height: 42,
                                className: "inline-block mr-5 ",
                                alt: "KiralamaTakvimi Logo",
                                loading: "lazy"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "font-openSans text-xl lg:text-3xl text-brand-black lg:text-orange",
                                        children: props.baslik
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-sm text-brand-gray mt-1",
                                        children: props.description
                                    })
                                ]
                            }),
                            props.showall && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                href: props.showall,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    className: "text-brand-black font-bold text-13 lg:hidden ml-auto",
                                    children: [
                                        all,
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_bs_BsThreeDots__WEBPACK_IMPORTED_MODULE_11__/* .BsThreeDots */ .e, {
                                            size: "36",
                                            className: "inline-block text-brand-blue"
                                        })
                                    ]
                                })
                            }),
                            props.showall && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                href: props.showall,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: props.showall,
                                    className: "bg-primary font-ma font-bold !leading-[55px] text-sm text-white px-9 ml-auto hidden lg:block",
                                    children: showAll
                                })
                            })
                        ]
                    }),
                    error ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: "error"
                    }) : !data ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ListVilla_SkeletonView__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        isPhone: isPhone
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            DesktopView ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DesktopView, {
                                data: data
                            }) : null,
                            MobileView ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MobileView, {
                                data: data
                            }) : null
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ListVilla);


/***/ }),

/***/ 1550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84849);



var SkeletonView = function(param) {
    var isPhone = param.isPhone, _lengthMobile = param.lengthMobile, lengthMobile = _lengthMobile === void 0 ? 2 : _lengthMobile, _length = param.length, length = _length === void 0 ? 3 : _length, _flex = param.flex, flex = _flex === void 0 ? true : _flex, _width = param.width, width = _width === void 0 ? "ml:w-[350px]" : _width, _padding = param.padding, padding = _padding === void 0 ? "px-4" : _padding;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), mounted = ref[0], setMounted = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setMounted(true);
    }, []);
    if (isPhone && mounted) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat(flex ? "gap-x-2 snap-x" : "flex-col gap-y-2 snap-y", " flex overflow-x-hidden snap-mandatory ").concat(padding),
            children: Array.from({
                length: lengthMobile
            }).map(function(_, i) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-11/12 ".concat(width, " shrink-0 grow-0 basis-auto snap-start bg-white shadow-sm border border-gray-100 rounded-2xl overflow-hidden"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            height: 208,
                            containerClassName: "flex",
                            borderRadius: 0
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "p-4 border-b border-gray-100 flex justify-between",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-col gap-1 w-2/3",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            height: 18,
                                            width: "80%"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            height: 12,
                                            width: "50%"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-col items-end gap-1 w-1/3 text-right",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            height: 18,
                                            width: "90%"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            height: 10,
                                            width: "60%"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "p-3 flex justify-between bg-gray-50/50",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex items-center gap-1.5",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            circle: true,
                                            height: 14,
                                            width: 14
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            height: 10,
                                            width: 20
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex items-center gap-1.5",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            circle: true,
                                            height: 14,
                                            width: 14
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            height: 10,
                                            width: 20
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex items-center gap-1.5",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            circle: true,
                                            height: 14,
                                            width: 14
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            height: 10,
                                            width: 20
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }, i);
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6",
        children: Array.from({
            length: length
        }).map(function(_, i) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "".concat(i === 3 ? "hidden xl:flex" : i === 2 ? "hidden md:flex" : "flex", " flex-col bg-white shadow-sm border border-gray-100"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        height: 280,
                        borderRadius: 0,
                        containerClassName: "flex"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "p-6 border-b border-gray-100 flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col gap-2 w-1/2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        height: 24,
                                        width: "80%"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        height: 16,
                                        width: "60%"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col items-end gap-1 w-1/2 text-right",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        height: 24,
                                        width: "70%"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        height: 14,
                                        width: "50%"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "p-5 flex justify-between bg-gray-50/30",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        circle: true,
                                        height: 20,
                                        width: 20
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        height: 14,
                                        width: 30
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        circle: true,
                                        height: 20,
                                        width: 20
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        height: 14,
                                        width: 30
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        circle: true,
                                        height: 20,
                                        width: 20
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        height: 14,
                                        width: 30
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, i);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SkeletonView);


/***/ }),

/***/ 16625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useWindowSize; }
/* harmony export */ });
/* unused harmony export useDevice */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useWindowSize() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(undefined), width = ref[0], setWidth = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleResize = function handleResize() {
            setWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, []);
    return {
        width: width
    };
};
function useDevice() {
    var ref = useState({
        isMobile: undefined
    }), r = ref[0], setR = ref[1];
    useEffect(function() {
        var handleResize = // Handler to call on window resize
        function handleResize() {
            // Set window width/height to state
            if (window.innerWidth < 1024) {
                setR({
                    isMobile: true
                });
            } else {
                setR({
                    isMobile: false
                });
            }
        };
        // Add event listener
        window.addEventListener("resize", handleResize);
        // Call handler right away so state gets updated with initial window size
        handleResize();
        // Remove event listener on cleanup
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, []); // Empty array ensures that effect is only run on mount
    return r;
}


/***/ }),

/***/ 26279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var useVisible = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        rootMargin: "200px"
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var observer = new IntersectionObserver(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 1), entry = _param[0];
            if (entry.isIntersecting) {
                setIsVisible(true);
                observer.disconnect();
            }
        }, options);
        if (ref1.current) {
            observer.observe(ref1.current);
        }
        return function() {
            if (observer) observer.disconnect();
        };
    }, []);
    return [
        ref1,
        isVisible
    ];
};
/* harmony default export */ __webpack_exports__["Z"] = (useVisible);


/***/ }),

/***/ 62647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ getMobilePlatform; }
/* harmony export */ });
var getMobilePlatform = function() {
    if (false) {}
    var ua = navigator.userAgent;
    if (/Android/i.test(ua)) {
        return "android";
    }
    if (/iPhone|iPad|iPod/i.test(ua)) {
        return "ios";
    }
    return "other";
};


/***/ }),

/***/ 20943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 13375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 91566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ })

}]);